// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    COMPANIES_OVERVIEW_GET_DATA_REQUEST,
    GET_TOKEN_ONE_TIME
} from 'Redux/actionTypes';

// Actions
import {
    accountgetDataResult,
    getTokenOneTimeResult
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* getCompany({ payload }) {
    try {
        let QUERY_COMPANY = `
            query getCompany ($id: Int!) {
                result: getCompany (id: $id) {
                    id
                    name
                    status
                    timezone
                    username
                    email
                    sm
                    internal
                    cognitoAuth
                    crmId
                    dealerId
                    hasPromiles
                    timezoneId
                    dealer {
                        id
                        name
                        brandId
                        brand {
                            id
                            title
                        }
                    }
                    role {
                        id
                        name
                        description
                        isCustom
                        roleModules {
                            id
                            roleId
                            moduleId
                            module {
                                id
                                code
                                name
                                category
                            }
                            c
                            u
                            d
                            isDefault
                        }
                    }
                    nextScheduledAction
                    sendWelcomeEmail
                    devicesCount
                    createdOn
                    tacRequired
                    integrations {
                        integrationId
                        integration {
                            code
                        }
                        parameters
                        status
                    }
                    tags
                    registrationStatus
                    readonly
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY_COMPANY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            yield put(accountgetDataResult({ data: data.result }));
        } else {
            yield put(accountgetDataResult({ data: null }));
        }

    } catch (exc) {
        yield put(accountgetDataResult({ error: true }));
    }
}

function* getTokenOneTime({ payload }) {
    try {
        const MUTATION_CREATE_ONE_TIME_TOKEN = `
            mutation createOneTimeToken($username: String, $token: String, $authId: String) {
                createOneTimeToken(username: $username, token: $token, authId: $authId) {
                    id
                    url
                    expirationDate
                    createdOn
                }
            }
        `;

        const data = yield call(
            clientMutation,
            MUTATION_CREATE_ONE_TIME_TOKEN,
            {
                username: payload.username,
                token: payload.token,
                authId: payload.authId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.createOneTimeToken) {
            yield put(getTokenOneTimeResult(data.createOneTimeToken));
        } else {
            yield put(getTokenOneTimeResult(null));
        }
    } catch (exc) {
        ExceptionManager(exc, 'modules/.common/components/EntityTagPicker/redux/saga.js', 'entityTagPickerSearchEnityTagsRequest');
        yield put(getTokenOneTimeResult({ errorToken: true }));
    }
}

function* watchMethods() {
    yield takeEvery(COMPANIES_OVERVIEW_GET_DATA_REQUEST, getCompany);
    yield takeEvery(GET_TOKEN_ONE_TIME, getTokenOneTime);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}